import React, { Suspense, lazy } from 'react';
import { Route, Redirect } from 'react-router-dom';

import Can from '@/components/Can';
import * as V from '@/components/views';
import { Spinner } from '@/components/Spinner';
import { Account } from '@/components/Settings/Account';
import { ManageUsers, Preferences } from '@/components/Settings';
import { Organizations } from '@/components/Settings/Organizations';
import { ContractPlans } from '@/components/Settings/ContractPlans';
const ListReport = lazy(() => import('@/views/ListReport'));
const CreateReport = lazy(() => import('@/views/CreateReport'));
const ActionPlans = lazy(() => import('@/views/ActionPlans'));
const Rosa = lazy(() => import('@/views/ListReport/Report/Rosa'));
const AnsiZ = lazy(() => import('@/views/ListReport/Report/AnsiZ'));
const Reba = lazy(() => import('@/views/ListReport/Report/Reba'));
const Rula = lazy(() => import('@/views/ListReport/Report/Rula'));
const Owas = lazy(() => import('@/views/ListReport/Report/Owas'));
const Niosh = lazy(() => import('@/views/ListReport/Report/Niosh'));
const AngleTime = lazy(() => import('@/views/ListReport/Report/AngleTime'));
const StrainIndex = lazy(() => import('@/views/ListReport/Report/StrainIndex'));
const KimPushPull = lazy(() => import('@/views/ListReport/Report/KimPushPull'));
const LibertyMutual = lazy(() => import('@/views/ListReport/Report/LibertyMutual'));
const KimManualHandling = lazy(() => import('@/views/ListReport/Report/KimManualHandling'));
const Files = lazy(() => import('@/components/views/Files'));
const PsychosocialReportListEmployees = lazy(() => import('@/views/PsychosocialReport/EmployeesManagement'));
const PsychosocialReportSurveyManagement = lazy(() => import('@/views/PsychosocialReport/SurveyManagement/index'));
const PsychosocialReportCreateSurvey = lazy(() =>
	import('@/views/PsychosocialReport/SurveyManagement/CreateSurvey/index')
);
const PsychosocialReportCreateEmployees = lazy(() =>
	import('@/views/PsychosocialReport/EmployeesManagement/CreateEmployee/index.tsx')
);
const PsychosocialReportSurveyInfo = lazy(() => import('@/views/PsychosocialReport/SurveyManagement/SurveyInfo/index'));
const PsychosocialReportSurveyInfoComplete = lazy(() =>
	import('@/views/PsychosocialReport/SurveyManagement/SurveyInfoComplete/index')
);
const DashboardView = lazy(() => import('@/views/Dashboard'));
const UsersView = lazy(() => import('@/views/Users'));
const UploadView = lazy(() => import('@/views/Upload'));
const RotationReport = lazy(() => import('@/components/views/RotationReport'));
const RotationReportList = lazy(() => import('@/components/views/RotationReportList'));
const ReportsView = lazy(() => import('@/views/Reports'));
const PsychosocialAvaliation = lazy(() => import('@/pages/PsychosocialAvaliation'));

const ErgonomicWorkAnalysisList = lazy(() => import('@/views/ErgonomicWorkAnalysis'));
const ErgonomicWorkAnalysisReport = lazy(() => import('@/views/ErgonomicWorkAnalysis/Report'));
const SuperPreliminaryAnalysisList = lazy(() => import('@/views/SuperPreliminaryAnalysis'));

const reportRoutes = [
	{
		type: 'niosh',
		component: Niosh
	},
	{
		type: 'rula',
		component: Rula
	},
	{
		type: 'rosa',
		component: Rosa
	},
	{
		type: 'reba',
		component: Reba
	},
	{
		type: 'owas',
		component: Owas
	},
	{
		type: 'angle-time',
		component: AngleTime
	},
	{
		type: 'strain-index',
		component: StrainIndex
	},
	{
		type: 'kim-pp',
		component: KimPushPull
	},
	{
		type: 'kim-mho',
		component: KimManualHandling
	},
	{
		type: 'liberty-mutual',
		component: LibertyMutual
	},
	{
		type: 'ansi',
		component: AnsiZ
	},
	{
		type: 'preliminary-ergonomic-analysis',
		component: V.PreliminaryAnalysisForm
	}
];

export function PrivateRoutes() {
	return (
		<Route
			component={() => (
				<Suspense fallback={<Spinner />}>
					{Can('access', 'ergonomic') && (
						<>
							<Route exact path="/" component={DashboardView} />
							<Route exact path="/upload" component={UploadView} />
							<Route exact path="/files" component={Files} />
							<Route exact path="/reporting" component={ReportsView} />
							<Route exact path="/ergonomic-work-analysis" component={ErgonomicWorkAnalysisList} />
							<Route
								exact
								path="/ergonomic-work-analysis/report/:report_id?"
								component={ErgonomicWorkAnalysisReport}
							/>
							<Route exact path="/action-plans" component={ActionPlans} />
							<Route exact path="/rotation/report/:id?" component={RotationReport} />
							<Route exact path="/rotation" component={RotationReportList} />
							<Route exact path="/super-pea/new-document" component={V.MergePea} />
							<Route exact path="/super-pea" component={SuperPreliminaryAnalysisList} />
							<Route path="/reporting/list/:report_name/:custom_report_id?" component={ListReport} />
							<Route
								exact
								path="/reporting/create/:report_name/:custom_report_id?"
								component={CreateReport}
							/>
							<Route
								exact
								path="/reporting/personalised-report/:report_id/:file_id?"
								component={V.PersonalisedReport}
							/>

							{reportRoutes.map((report) => (
								<Route
									key={report.type}
									component={report.component}
									path={`/reporting/${report.type}/:file_id`}
								/>
							))}
						</>
					)}
					{Can('access', 'psychosocial') && (
						<>
							{!Can('access', 'ergonomic') && (
								<Route exact path="/">
									<Redirect to="/psychosocial-report/survey-management" />
								</Route>
							)}
							<Route isPublic exact path="/avaliation/:token" component={PsychosocialAvaliation} />
							<Route
								exact
								path="/psychosocial-report/employees"
								component={PsychosocialReportListEmployees}
							/>
							<Route
								exact
								path="/psychosocial-report/survey-management"
								component={PsychosocialReportSurveyManagement}
							/>
							<Route
								exact
								path="/psychosocial-report/survey-management/create"
								component={PsychosocialReportCreateSurvey}
							/>
							<Route
								exact
								path="/psychosocial-report/survey-management/informations/:survey_id"
								component={PsychosocialReportSurveyInfo}
							/>
							<Route
								exact
								path="/psychosocial-report/survey-management/completed/:survey_id"
								component={PsychosocialReportSurveyInfoComplete}
							/>
							<Route
								exact
								path="/psychosocial-report/employees/create/:employee_id?"
								component={PsychosocialReportCreateEmployees}
							/>
						</>
					)}
					<Route exact path="/users" component={UsersView} />
					<Route exact path="/settings" component={Account} />
					<Route exact path="/settings/account" component={Account} />
					{Can('settings', 'management') && (
						<>
							<Route
								exact
								path="/settings/companies"
								component={process.env.REACT_APP_CONTRACT_PLANS ? ContractPlans : Organizations}
							/>
							<Route exact path="/settings/manage-users" component={ManageUsers} />
							{Can('access', 'ergonomic') && (
								<>
									<Route exact path="/settings/preferences" component={Preferences} />
									<Route
										exact
										path="/settings/personalised-reports"
										component={V.PersonalisedReportsList}
									/>
									<Route
										exact
										path="/settings/personalised-reports/manage/:report_id?"
										component={V.PersonalisedReportsManager}
									/>
								</>
							)}
						</>
					)}
				</Suspense>
			)}
		/>
	);
}
